
import UnsavedChangeConfirmPopup from 'material/unsavedchangeconfirmpopup/unsavedchangeconfirmpopup';
import { useDispatch, useSelector } from 'react-redux';
import { displayModal, history } from '@insticator/insticator-ui'
import { updateCurrentPage } from 'state/slices/app';
import UnsavedProductManagerConfirmPopup from 'material/unsavedchangeconfirmpopup/unsavedproductmanagerconfirmpopup';
import { useCallback } from 'react';


export const useNavigation = () => {
  const dispatch = useDispatch()
  const { commentingUnitConfig, tempCommentingUnitConfig, displayConfig, tempDisplayConfig } = useSelector(state => state.commentingV2)
	const { productManagerConfig, tempProductManagerConfig } = useSelector(state => state.productManager)
  const { trendingNowConfig, tempTrendingNowConfig } = useSelector(state => state.trendingNowV2)
  const { articleSentimentConfig, tempArticleSentimentConfig } = useSelector(state => state.articleSentimentV2)

  
  const handleNavigation = useCallback(async(route) => {
    // Commenting 2.0 - Add a check if there's an unsaved changes in commenting config v2
    const isCommentingConfigChanged = !(JSON.stringify(commentingUnitConfig) === JSON.stringify(tempCommentingUnitConfig));
    const isProductManagerConfigChanged = !(JSON.stringify(productManagerConfig) === JSON.stringify(tempProductManagerConfig));

    const isTrendingNowConfigsChanged = !(JSON.stringify(trendingNowConfig) === JSON.stringify(tempTrendingNowConfig));
    
    const isArticleSentimentConfigsChanged  = !(JSON.stringify(articleSentimentConfig) === JSON.stringify(tempArticleSentimentConfig));

    const currentLocation = history.location.pathname

    if(currentLocation.includes('productmanager') && isProductManagerConfigChanged) 
     dispatch(displayModal(true, <UnsavedProductManagerConfirmPopup route={route} />))
    else if(currentLocation.includes('commenting/configuration') && isCommentingConfigChanged) 
      dispatch(displayModal(true, <UnsavedChangeConfirmPopup newPage={route} />))
    else if(currentLocation.includes('trendingnow/configuration') && isTrendingNowConfigsChanged)
      dispatch(displayModal(true, <UnsavedChangeConfirmPopup newPage={route} />))
    else if(currentLocation.includes('articlesentiment/configuration') && isArticleSentimentConfigsChanged)
      dispatch(displayModal(true, <UnsavedChangeConfirmPopup newPage={route} />))
    else
      dispatch(updateCurrentPage(route))
    }, [articleSentimentConfig, commentingUnitConfig, dispatch, productManagerConfig, tempArticleSentimentConfig, tempCommentingUnitConfig, tempProductManagerConfig, tempTrendingNowConfig, trendingNowConfig])

  return {
    handleNavigation
  }
}